export const THEME_LIGHT = 'synapse-light';
export const THEME_DARK = 'synapse-dark';
export const DEFAULT_THEME = THEME_LIGHT;
export const DEFAULT_LANGUAGE = 'en-EN';
